import React from 'react';
import { MenuItem } from '@mui/material';
import CustomModal from '../../../../../components/Modal/CustomModal';
import { CustomSelectAndChildren } from '../../../../../components/CustomSelectAndChildren';
import { CustomTextField } from '../../../../../components/CustomTextField';
import {DEVICE_TYPE, MIN_MAX_SIO, SIOS_TYPE} from '../Model/Models';
import CreateSiosApp from "../Functionality/CreateSiosApp";

const CreateSIOSModal = (props) => {
    const { onHide, controllerId=null, setModified } = props;

    const {
        t,
        resetValues,
        handleSubmit,
        sios,
        handleChange,
        emptyFields,
        isValidPortNumber,
        controller
    } = CreateSiosApp({onHide, controllerId, setModified});

    return (
        <CustomModal
            title='create_sio'
            size='lg'
            buttonConfirm='confirm'
            {...props}
            onHide={() => {
                onHide();
                resetValues();
            }}
            onConfirm={() => {
                handleSubmit();
            }}
            classNameBody="pt-2"
        >
            <div className='row'>
                <div className='col-sm-12 col-md-6 col-xl-6 col-xxl-6 col-lg-6'>
                    <CustomTextField id={"txt_csm_name"}
                                     trans={"name"}
                                     name={"name"}
                                     type={"text"}
                                     value={sios.name}
                                     onChange={handleChange}
                                     required={true}
                                     emptyFields={emptyFields}
                                     length={128}
                    />
                </div>
                {controllerId == null &&
                    <div className='col-sm-12 col-md-6 col-xl-6 col-xxl-6 col-lg-6'>
                        <CustomSelectAndChildren id={"slt_csm_controller"}
                                                 name={"hidId"}
                                                 trans={"controller"}
                                                 value={sios.hidId}
                                                 onChange={handleChange}
                                                 required={true}
                                                 emptyFields={emptyFields}
                                                 showNoSelectionOption={false}
                        >
                            {Array.isArray(controller) &&
                            controller.map((item) => (
                                <MenuItem key={item.id} value={item.id}>
                                    {item.name}
                                </MenuItem>
                            ))}
                        </CustomSelectAndChildren>
                    </div>
                }

                <div className='col-sm-12 col-md-6 col-xl-6 col-xxl-6 col-lg-6'>
                    <CustomTextField id={"txt_csm_port_number"}
                                     trans={"port_number"}
                                     name={"portNumber"}
                                     type={"number"}
                                     value={sios.portNumber}
                                     onChange={handleChange}
                                     required={true}
                                     emptyFields={emptyFields}
                                     length={1}
                                     isValid={isValidPortNumber}
                                     isValidText={t("it_must_be_greater_than_x_or_equal_to", {min:MIN_MAX_SIO.PORT_NUMBER.start, max:MIN_MAX_SIO.PORT_NUMBER.end})}
                                     helperText={t("it_must_be_greater_than_x_or_equal_to", {min:MIN_MAX_SIO.PORT_NUMBER.start, max:MIN_MAX_SIO.PORT_NUMBER.end})}
                    />
                </div>
                <div className='col-sm-12 col-md-6 col-xl-6 col-xxl-6 col-lg-6'>
                    <CustomSelectAndChildren id={"slt_csm_controller"}
                        name={"deviceType"}
                        trans={"device_type"}
                        value={sios.deviceType}
                        onChange={handleChange}
                        required={true}
                        emptyFields={emptyFields}
                        showNoSelectionOption={false}
                    >
                        {Object.values(DEVICE_TYPE).map((item) => (
                            <MenuItem key={item.id} value={item.id}>
                                {item.name}
                            </MenuItem>
                        ))}
                    </CustomSelectAndChildren>
                </div>
                <div className='col-sm-12 col-md-6 col-xl-6 col-xxl-6 col-lg-6'>
                    <CustomSelectAndChildren id={"slt_csm_controller"}
                        name={"sioType"}
                        trans={"sio_type"}
                        value={sios.sioType}
                        onChange={handleChange}
                        required={true}
                        emptyFields={emptyFields}
                        disabled={sios.deviceType == null}
                        showNoSelectionOption={false}
                    >
                        {Object.values(SIOS_TYPE).filter((item) => item.type === sios.deviceType).map((item) => (
                            <MenuItem key={item.id} value={item.id}>
                                {t(item.name)}
                            </MenuItem>
                        ))}
                    </CustomSelectAndChildren>
                </div>
            </div>
        </CustomModal>
    );
};

export default CreateSIOSModal;
